import { Table, TableBody, TableCell, TableHead, TableRow } from '@trackman/web-shared-components';
import Paragraph from 'components/TextComps/Paragraph';
import { ReactComponent as PlusIcon } from 'images/icons/Plus.svg';
import { ReactComponent as TrashIcon } from 'images/icons/Trash.svg';
import { useState } from 'react';
import { useOrganizationEditorStore } from 'stores/Admin/Editors/OrganizationEditorStore';
import { InviteInstructorsModal } from '../InviteInstructorsModal/InviteInstructorsModal';

type TableRow = {
  id: string;
  name: string;
  email: string;
};

export const InstructorsTable = () => {
  const [isInviteInstructorsModalOpen, setIsInviteInstructorsModalOpen] = useState(false);

  const { instructors, setInstructors } = useOrganizationEditorStore();
  const rowsDisplay: TableRow[] = instructors.map((instructor) => {
    return {
      id: instructor.id,
      name: instructor.fullName,
      email: instructor.email,
    };
  });

  const removeInstructor = (id: string) => {
    setInstructors(instructors.filter((instructor) => instructor.id !== id));
  };

  return (
    <div className='tmu-table-wrapper admin-edit-section'>
      <div className='table-subheading'>
        <strong>Instructors</strong>
        <button onClick={() => setIsInviteInstructorsModalOpen(true)} className='add-button styled-button primary'>
          <PlusIcon />
          <span>Invite Instructors</span>
        </button>
      </div>
      <Table sx={{ minWidth: 750 }} className='tmu-table admin-table'>
        <TableHead>
          <TableRow>
            <TableCell sx={{ width: 300 }}>Name</TableCell>
            <TableCell sx={{ width: 900 }}>Email</TableCell>
            <TableCell sx={{ width: 200 }}></TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {rowsDisplay.length ? (
            rowsDisplay.map((instructor) => {
              return (
                <TableRow hover key={instructor.id}>
                  <TableCell>{instructor.name}</TableCell>
                  <TableCell className='instructor-email'>{instructor.email}</TableCell>
                  <TableCell>
                    <div className='action-buttons'>
                      <button className='row-button' onClick={() => removeInstructor(instructor.id)}>
                        <TrashIcon />
                      </button>
                    </div>
                  </TableCell>
                </TableRow>
              );
            })
          ) : (
            <TableRow>
              <TableCell colSpan={3}>
                <Paragraph>
                  <>No instructors added.</>
                </Paragraph>
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
      <InviteInstructorsModal
        isOpen={isInviteInstructorsModalOpen}
        onClose={() => setIsInviteInstructorsModalOpen(false)}
        setInstructors={setInstructors}
        instructors={instructors}
      />
    </div>
  );
};
